import React from 'react';
import { Button } from '../../design-system/Button';
import { OnboardingProgress } from '../../../types/coach';

interface ReviewStepProps {
  onComplete: () => void;
  onFinish?: () => void;
  progress?: OnboardingProgress;
}

const ReviewStep: React.FC<ReviewStepProps> = ({ onFinish, progress }) => {
  return (
    <div className="space-y-6">
      <div className="text-center py-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">
          🎉 Almost There!
        </h3>
        <p className="text-lg text-gray-600 mb-2">
          Your profile is {progress?.profile_completion_percentage || 0}% complete
        </p>
        
        {progress?.profile_completion_percentage && progress.profile_completion_percentage >= 80 ? (
          <>
            <p className="text-gray-600 mb-6">
              Great job! Your profile is complete enough to start accepting clients.
            </p>
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6 inline-block">
              <p className="text-green-700">
                ✓ You can now accept clients!
              </p>
            </div>
          </>
        ) : (
          <p className="text-gray-600 mb-6">
            Your profile needs to be at least 80% complete to accept clients.
            You can finish the remaining steps from your profile settings.
          </p>
        )}
      </div>

      <div className="border-t pt-6">
        <h4 className="font-medium text-gray-900 mb-3">Completed Steps:</h4>
        <ul className="space-y-2">
          {progress?.completed_steps.map((step) => (
            <li key={step} className="flex items-center text-green-600">
              <span className="mr-2">✓</span>
              <span className="capitalize">{step.replace(/_/g, ' ')}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="flex justify-end pt-6">
        <Button onClick={onFinish} size="lg">
          Complete Onboarding
        </Button>
      </div>
    </div>
  );
};

export default ReviewStep;